
import { Button } from '05-ui-kit';
import { computed, ref, watch } from '@vue/composition-api';
import { declination, paginationArray } from '@artmizu/utils';
import type Pagination from '~/type/Pagination';
interface Props {
  quantityOnPage: number;
  pagination?: Pagination;
  /*
  * Нужен для хелпера declination
  */
  entitiesList?: [string, string, string];
  /**
    *  Ссылка для пагинации, чтобы поисковики читали эти ссылки
  */
  link?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  quantityOnPage: {
    key: "quantityOnPage",
    required: true,
    type: Number
  },
  pagination: {
    key: "pagination",
    required: false,
    type: null,
    default: () => ({
      count: 1,
      current: 1,
      itemQuantity: 0
    })
  },
  entitiesList: {
    key: "entitiesList",
    required: false,
    type: Array,
    default: () => ['товар', 'товара', 'товаров']
  },
  link: {
    key: "link",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const path = ref<ReturnType<typeof paginationArray>>([]);
  const mobilePath = ref<ReturnType<typeof paginationArray>>([]);
  const totalQuantity = computed(() => {
    /**
    * На предпоследней странице мы должны вывести остаток того, сколько еще нужно подгрузить сущностей
    * зачастую там не столько, сколько может быть на странице, а меньше. Например если на странице 100 сущностей,
    * а на каждой странице мы выводим по 30, то на последней странице нужно подгрузить 10, тут это и считаем
    */
    if (props.pagination.current === props.pagination.count - 1 && props.pagination.itemQuantity % props.quantityOnPage !== 0) return props.pagination.itemQuantity % props.quantityOnPage;else return props.quantityOnPage;
  });
  const declinationValue = computed(() => {
    return declination(totalQuantity.value, props.entitiesList);
  });
  watch([() => props.pagination.count, () => props.pagination.current], () => {
    setPath();
  }, {
    immediate: true
  });
  function setPath() {
    path.value = paginationArray({
      current: props.pagination.current,
      count: props.pagination.count
    });
    mobilePath.value = paginationArray({
      current: props.pagination.current,
      count: props.pagination.count,
      visiblePageCount: 5
    });
  }
  function changePage(num: number) {
    if (num !== props.pagination.current) emit('change-page', num);
  }
  function loadMore(num: number) {
    emit('load-more', num);
  }
  return {
    path,
    mobilePath,
    totalQuantity,
    declinationValue,
    changePage,
    loadMore
  };
};
__sfc_main.components = Object.assign({
  Button
}, __sfc_main.components);
export default __sfc_main;
